import { useContext } from 'react';

import { TabsContext } from './TabsContext';
import { TabsState } from './types';

export const useTabsState = <T extends string>(): TabsState<T> | undefined =>
  useContext(TabsContext);
